import { ChangeDetectionStrategy, Component, ElementRef, TemplateRef, contentChild, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  template: `
    <mat-card class="card" [class]="cardClass()">
      @if (showHeader()) {
        <mat-card-header class="card__header" [class]="headerClass()">
          <mat-card-title id="step-start" class="card__title">
            {{ cardTitle() }}
            @if (headerTitleTemplate(); as headerTitle) {
              <ng-container [ngTemplateOutlet]="headerTitle"></ng-container>
            }
          </mat-card-title>
          @if (headerOptionsTemplate(); as headerOptions) {
            <ng-container [ngTemplateOutlet]="headerOptions"></ng-container>
          }
        </mat-card-header>
      }

      @if (showContent()) {
        <mat-card-content class="card__content" [style.padding.px]="padding()">
          <ng-content></ng-content>
        </mat-card-content>
      }

      @if (actionTemplate(); as actions) {
        <mat-card-actions class="card__actions" [class]="actionClass()">
          <ng-container [ngTemplateOutlet]="actions"></ng-container>
        </mat-card-actions>
      }
    </mat-card>
  `,
  styles: [
    `
      .card {
        display: block !important;

        &__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px;
          border-bottom: 1px solid var(--accent-300);
        }

        &__title {
          margin-right: auto;
          text-align: left;
          margin: 0;
          color: var(--primary-500);
          font-size: 1rem;
          font-weight: 600;
        }

        &__content {
          padding-bottom: 0;
        }

        &__actions {
          border-top: 1px solid var(--accent-300);
          padding: 20px;
        }
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
  cardClass = input<string>();
  headerClass = input<string>();
  actionClass = input<string>();
  cardTitle = input<string>();
  showHeader = input<boolean>(true);
  showContent = input<boolean>(true);
  padding = input<number>(24);
  readonly headerOptionsTemplate = contentChild<TemplateRef<ElementRef>>('headerOptionsTemplate');
  readonly headerTitleTemplate = contentChild<TemplateRef<ElementRef>>('headerTitleTemplate');
  readonly actionTemplate = contentChild<TemplateRef<ElementRef>>('actionTemplate');
}
